import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { toAquacultureSites } from './mappers';
import type { AquacultureSite } from './types';

const SITES_URL = 'https://api.fiskeridir.no/pub-aqua/api/v1/sites';

/** The first ten register sites whose name matches. A public API outside our backend. */
async function searchAquacultureSites(name: string): Promise<AquacultureSite[]> {
    const response = await fetch(`${SITES_URL}?name=${name}&range=0-9`);
    return toAquacultureSites(await response.json());
}

export const AQUACULTURE_SITES_KEY = 'aquacultureSites';

/**
 * A search function for the site autocomplete. Each search goes through the query cache, so a
 * repeated name within the stale time is served from it.
 */
export function useSearchAquacultureSites(): (name: string) => Promise<AquacultureSite[]> {
    const queryClient = useQueryClient();
    return useCallback(
        (name: string) =>
            queryClient.fetchQuery({
                queryKey: [AQUACULTURE_SITES_KEY, name],
                queryFn: () => searchAquacultureSites(name),
            }),
        [queryClient]
    );
}
